import {
  createBarSeries,
  createBarCircleSeries,
  createLineSeries
} from './echartOption';
import config from './config';
import { axisFormatter, dealTips } from '../../tools/index';

/*
 * @Description:
 * @Date: 2020-11-17 10:43:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:40:11
 */

const randomNumber = (min, max) => {
  return parseInt(Math.random() * (max - min) + min);
};
const getAllChart = (
  options,
  series0data,
  keys = ['line1', 'line2', 'line', 'bar2', 'bar3', 'bar', 'radar', 'radar2'],
  xAxisData,
  finalDataCount
) => {
  const infoArr = [
    {
      type: 'line1',
      series0data: series0data
    },
    {
      type: 'line2',
      series0data: series0data
    },
    {
      type: 'line',
      series: createLineSeries(series0data)
    },
    {
      type: 'bar2',
      series: createBarSeries(series0data, true)
    },
    {
      type: 'bar3',
      series: createBarCircleSeries(series0data, true)
    },
    {
      type: 'bar',
      axisChange: true,
      series: createBarSeries(series0data)
    },
    {
      type: 'radar',
      series0data: [
        {
          value: series0data.reduce((pre, cur) => {
            pre.push(cur.value);
            return pre;
          }, []),
          itemStyle: { color: '#6B66FF', borderWidth: 4 }
        }
      ]
    },
    {
      type: 'radar2',
      series0data: [
        {
          value: series0data.reduce((pre, cur) => {
            pre.push(cur.value);
            return pre;
          }, []),
          itemStyle: { color: '#6B66FF', borderWidth: 4 }
        }
      ]
    }
  ];
  return infoArr
    .filter(i => {
      if (['radar2', 'radar'].includes(i.type)) {
        return keys.includes(i.type) && xAxisData.length > 1;
      }
      return keys.includes(i.type);
    })
    .reduce((pre, cur) => {
      const { type, axisChange, series0data, series } = cur;
      const obj = {};
      if (series0data) {
        obj['series0data'] = series0data;
      }
      if (series) {
        obj['series'] = series;
      }
      const _options = Object.assign({}, options);
      if (axisChange) {
        // 交换 x 和 y 轴
        const { xAxis, yAxis, _xAxis = yAxis, _yAxis = xAxis } = _options;
        _options['xAxis'] = _xAxis;
        _options['yAxis'] = _yAxis;
      }
      if (type == 'radar' || type == 'radar2') {
        delete _options['xAxis'];
        delete _options['yAxis'];
        _options['radar'] = Object.assign({}, config['radar'], {
          indicator: (xAxisData || []).reduce((pre, cur, index) => {
            pre.push({
              text: `${cur}：${series0data[0]['value'][index]}单`,
              max: finalDataCount
            });
            return pre;
          }, []),
          shape: type == 'radar2' ? 'polygon' : 'circle'
        });
      }
      const res = {
        echartType: type === 'radar2' ? 'radar' : type,
        echartOption: Object.assign({}, _options, obj)
      };
      if (type === 'radar' || type === 'radar2') {
        res['echartStyle'] = {
          marginTop: '30px',
          height: '500px'
        };
      }
      if (type === 'bar') {
        res['echartStyle'] = {
          height: `${Math.max(xAxisData.length * 50, 400)}px`
        };
      }
      pre.push(res);
      return pre;
    }, []);
};

export const getRadioOptions = ({
  ix,
  title,
  remark,
  questionType,
  isMustFill,
  header,
  data,
  finalDataCount,
  xAxisData,
  series0data
} = obj) => {
  const maxLabelLength = series0data.reduce((pre, cur) => {
    pre = Math.max(cur.name.length, pre);
    return pre;
  }, 0);
  const hasZero = series0data.some(i => i.value == 0);
  const fLength = xAxisData.length;
  let templateArr = [
    'bar3dType1',
    'pie3dType1',
    'pie3dType2',
    'pie3dType3',
    'pieGroup1',
    'pieGroup2',
    'pieGroup'
  ];
  if (fLength > 4) {
    templateArr = ['pie3dType1', 'pie3dType2', 'pie3dType3', 'pieGroup2'];
    if (fLength < 7) {
      templateArr.push('pieGroup1');
    }
  }
  if (fLength > 4 && maxLabelLength > 13) {
    templateArr = ['bar3dType1'];
  }
  if (hasZero) {
    templateArr = ['bar3dType1'];
    if (maxLabelLength < 13) {
      if (fLength < 7) {
        templateArr.push('pieGroup1');
      }
      if (fLength < 4) {
        templateArr.push('pieGroup');
      }
    }
  }
  if (maxLabelLength > 13) {
    templateArr = ['bar3dType1'];
  }
  // templateArr = ['pie3dType1'];
  const templateName =
    templateArr[randomNumber(0, templateArr.length)] || templateArr[0];
  return {
    key: 'type1-' + ix,
    value: {
      header: {
        index: ix,
        title: title + ` (${questionType})`,
        name: title,
        remark,
        isMustFill
      },
      customComponents: [
        {
          options: {
            table: {
              header: header,
              data: data,
              finalDataCount,
              isNormal: true
            },
            series0data: series0data,
            finalDataCount: finalDataCount
          },
          com: require(`../customCharts/${templateName}`).default
        }
      ]
    }
  };
};

export const getMultipleChoiceOptions = ({
  ix,
  title,
  remark,
  questionType,
  isMustFill,
  header,
  data,
  finalDataCount,
  xAxisData,
  series0data
} = obj) => {
  const hasZero = series0data.some(i => i.value == 0);
  const maxLabelLength = series0data.reduce((pre, cur) => {
    pre = Math.max(cur.name.length, pre);
    return pre;
  }, 0);
  const fLength = xAxisData.length;
  let templateArr = ['line1', 'line2', 'line', 'bar2', 'bar3', 'bar', 'radar2'];
  if (maxLabelLength > 13 || series0data.length < 3) {
    templateArr = ['line1', 'line2', 'line', 'bar2', 'bar3'];
  }
  const useChart =
    Math.random() > 0.5 || maxLabelLength > 12 || fLength > 5 || hasZero;
  if (useChart) {
    const configArr = getAllChart(
      {
        tooltip: {
          formatter: function(params) {
            const { axisValue, value } = params[0] || params || {};
            return dealTips(axisValue, value, '单');
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: '选项',
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#666',
              fontSize: 11,
              lineHeight: 18
            },
            formatter: function(params) {
              return axisFormatter(params, xAxisData.length);
            }
          }
        },
        yAxis: {
          name: '任务数（单）'
        }
      },
      series0data,
      templateArr,
      xAxisData,
      finalDataCount
    );
    return {
      key: 'type2-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionType})`,
          name: title,
          isMustFill
        },
        table: { header, data, finalDataCount },
        echart: [configArr[randomNumber(0, configArr.length)] || configArr[0]]
      }
    };
  } else {
    const templateArr = ['pieGroup1'];
    const templateName =
      templateArr[randomNumber(0, templateArr.length)] || templateArr[0];
    return {
      key: 'type1-' + ix,
      value: {
        header: {
          index: ix,
          title: title + ` (${questionType})`,
          name: title,
          remark,
          isMustFill
        },
        customComponents: [
          {
            options: {
              table: {
                header: header,
                data: data,
                finalDataCount,
                isNormal: true
              },
              series0data: series0data,
              finalDataCount: finalDataCount
            },
            com: require(`../customCharts/${templateName}`).default
          }
        ]
      }
    };
  }
};

export const getGradeOptions = ({
  ix,
  title,
  remark,
  questionType,
  isMustFill,
  header,
  data,
  finalDataCount,
  xAxisData,
  series0data
} = obj) => {
  const configArr = getAllChart(
    {
      tooltip: {
        formatter: function(params) {
          const { axisValue, value } = params[0] || params || {};
          return dealTips(axisValue, value, '单');
        }
      },
      xAxis: {
        type: 'category',
        data: xAxisData
      },
      yAxis: {
        name: '任务数（单）'
      }
    },
    series0data,
    ['line', 'line2', 'bar2', 'bar3', 'radar'],
    xAxisData,
    finalDataCount
  );
  return {
    key: 'type2-' + ix,
    value: {
      header: {
        index: ix,
        title: title + ` (${questionType})`,
        name: title,
        remark,
        isMustFill
      },
      table: { header, data, finalDataCount },
      echart: [configArr[randomNumber(0, configArr.length)] || configArr[0]]
    }
  };
};
